import TrustpilotApiService from '../module/ecocode-trustpilot/service/trustpilot-api.service';

Shopware.Application.addServiceProvider('ecocodeTrustpilotApiService', container => {
    const initContainer = Shopware.Application.getContainer('init');
    return new TrustpilotApiService(initContainer.httpClient, container.loginService, Shopware.Context.api);
});
